<template>
  <TagHub :slugs="[route.params.slug]" />
</template>

<script setup>
  // Remount per tag and page, so following a related-tag link fetches it.
  definePageMeta({ key: (route) => route.fullPath })

  const route = useRoute()
</script>
